// frontend/src/pages/AuditLog.js
import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import AuthContext from '../context/AuthContext';
import { HistoryIcon as History, CloseIcon as X, CalendarIcon as Calendar } from '../components/Icons';

const AuditLog = () => {
    const { API_URL, user } = useContext(AuthContext);
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pagination, setPagination] = useState({ page: 1, pages: 1, total: 0 });
    const [filters, setFilters] = useState({ action: '', entityType: '' });

    const actionOptions = [
        { value: 'create', label: 'Erstellt', color: 'bg-primary-container' },
        { value: 'update', label: 'Aktualisiert', color: 'bg-secondary-container' },
        { value: 'delete', label: 'Gelöscht', color: 'bg-error-container' }
    ];

    useEffect(() => {
        fetchLogs();
    }, [pagination.page, filters]);

    const fetchLogs = async () => {
        try {
            const config = { headers: { Authorization: `Bearer ${user.token}` } };
            const params = new URLSearchParams({ page: pagination.page, limit: 20, ...filters });
            const { data } = await axios.get(`${API_URL}/audit?${params}`, config);
            setLogs(data.logs);
            setPagination(data.pagination);
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    };

    if (loading) return <div className="flex justify-center items-center h-64"><div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin"></div></div>;

    return (
        <div className="container mx-auto p-4 max-w-7xl animate-fade-in">
            <div className="mb-8 flex items-center gap-3">
                <div className="w-12 h-12 rounded-xl bg-primary-container text-primary-onContainer flex items-center justify-center"><History style={{ fontSize: 28 }} /></div>
                <div><h1 className="text-display-small font-bold">Aktivitäts-Log</h1><p className="text-body-medium text-surface-onVariant">{pagination.total} Einträge</p></div>
            </div>

            <div className="md3-card-outlined p-4 mb-6 flex gap-4">
                <select value={filters.action} onChange={(e) => setFilters({ ...filters, action: e.target.value })} className="md3-textfield-outlined">
                    <option value="">Alle Aktionen</option>
                    {actionOptions.map(a => <option key={a.value} value={a.value}>{a.label}</option>)}
                </select>
                <select value={filters.entityType} onChange={(e) => setFilters({ ...filters, entityType: e.target.value })} className="md3-textfield-outlined">
                    <option value="">Alle Typen</option>
                    {['user', 'event', 'group', 'task'].map(e => <option key={e} value={e}>{e}</option>)}
                </select>
            </div>

            <div className="space-y-3">
                {logs.map(log => (
                    <div key={log._id} className="md3-card-outlined p-4 flex items-start gap-4">
                        <div className="w-10 h-10 rounded-full bg-secondary-container flex items-center justify-center font-bold">{log.user?.username?.charAt(0) || '?'}</div>
                        <div className="flex-1">
                            <div className="flex items-center gap-2 mb-1">
                                <span className="font-bold">{log.user?.username || 'System'}</span>
                                <span className={`px-2 py-0.5 rounded text-label-small ${actionOptions.find(a => a.value === log.action)?.color || 'bg-surface-variant'}`}>{log.action}</span>
                                <span className="px-2 py-0.5 rounded bg-surface-variant text-label-small">{log.entityType}</span>
                            </div>
                            <p className="text-body-medium mb-1">{log.description}</p>
                            <p className="text-body-small text-surface-onVariant flex items-center gap-1"><Calendar style={{ fontSize: 14 }} />{new Date(log.createdAt).toLocaleString('de-DE')}</p>
                        </div>
                    </div>
                ))}
            </div>

            {pagination.pages > 1 && (
                <div className="flex justify-center gap-2 mt-8">
                    <button onClick={() => setPagination({ ...pagination, page: pagination.page - 1 })} disabled={pagination.page === 1} className="md3-btn-tonal">Zurück</button>
                    <span className="px-4 flex items-center">Seite {pagination.page} von {pagination.pages}</span>
                    <button onClick={() => setPagination({ ...pagination, page: pagination.page + 1 })} disabled={pagination.page === pagination.pages} className="md3-btn-tonal">Weiter</button>
                </div>
            )}
        </div>
    );
};

export default AuditLog;
